export default __webpack_public_path__ + "static/media/folder-add-24-px.e5115c49.svg";